import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import { ReactComponent as ShareBoxFilled } from '../../resources/share-box-filled.svg';
import { ReactComponent as ShareBoxOutlined } from '../../resources/share-box-outlined.svg';
import { PUBLISHED_BLUE } from './tokens';

const StyledShareFilledIcon = styled(ShareBoxFilled, {
  shouldForwardProp: (prop) => prop !== 'changes',
})(({ theme, changes }) => ({
  color: changes === 'some' ? theme.palette.primary.main : PUBLISHED_BLUE,
  // Nothing left to propose: the glyph still says "published", but faded to
  // match the button being inert.
  ...(changes === 'none' && { opacity: 0.5 }),
}));

const StyledShareOutlineIcon = styled(ShareBoxOutlined)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

// Outlined until the entity is public, then published blue - coral while the
// private copy has something to propose, faded once it has nothing. Entities
// that never compute a diff leave `changes` alone and stay plain blue.
export default function ShareVisibilityIcon({ isPublic, changes, ...props }) {
  return isPublic
    ? <StyledShareFilledIcon changes={changes} {...props} />
    : <StyledShareOutlineIcon {...props} />;
}

ShareVisibilityIcon.propTypes = {
  isPublic: PropTypes.bool,
  changes: PropTypes.oneOf(['unknown', 'some', 'none']),
};

ShareVisibilityIcon.defaultProps = {
  isPublic: false,
  changes: 'unknown',
};
